export class RateBucketDetail
{
	rateBucketDetailId: number;
	rateBucketId: number;

	createDate: Date;
	lastUpdate: Date;

	name: number;
	rateBucketName: string;
	description: number;
	publicRateNote: number;

	rateBucketType: number;

	startDate: Date;
	endDate: Date;
	listPrice: number;
	listPriceAdjustmentPercent: number;
	listPriceAdjustmentAmount: number;

	// yieldManager Inputs
	minimumPriceSetByManager: number;
	minimumPriceSetByOwner: number;

	// low (1) to peak (5)
	seasonCategory: number;

	seasonOccupancy: number;

	// as decimal, ie .50
	discountMaxPercent: number;

	// how many days forward to start discounting
	discountLookForwardDays: number;

	// how many days to look forward to create special headlines
	discountHeadlineSpecialsLookForwardDays: number;

	// how many minimum nights to consider when creating special headlines
	discountHeadlineSpecialsMinNightsToAnalyze: number;

	// fixed value set by use to indicate how many nights to group together as one
	// price.
	discountIntervalDays: number;

	// the number of consecutive days we want the rate engine to process in a row so
	// it does not just break before a rate season end
	discountCombinationDays: number;

	// number of algorithm.
	discountAlorithm: string;

	/*
	 *
	 *
	 * Dynamic Pricing Engine (DPE) Levers
	 */

	minStayExpected: number;
	maxStayExpected: number;
	avgStayBySeason: number;

	/*
	 * shortTermGapNightsMultiplier Range: 0-1 in decimal, ie .3 At 0, we want 0% of our shortTermGaps rented - so there will be no adjustment if they rent 1 out of
	 * 4 nights At 1, we want 100% of our shortTermGaps rented - so there would be a 3 night penalty to price if they rented 1 out of 4 nights
	 */
	shortTermGapMultiplier: number; // used

	/*
	 *
	 * shortTermGapPenaltyPercent' to determine how much penalty to apply. For example, if 2.8 nights desired by only 2 rented, only apply xxx% of the .8 night
	 * penalty (ie .5)
	 */
	shortTermGapPenaltyPercent: number; // used


	/*
	*
	* Range: 0-10 as integer.  Determines how many nights of revenue minimum to charge a guest if the avaialble nights is less than the minExpected nights.
	* EXAMPLE: Assume a 1 nights gap between two Christmas bookings.  A setting of 3 nights will allow the guest to book just the 1 night, but charge them
	* for 3 even though it is a perfect back to back.
	*
	*/
	shortTermGapMinNightsReqRev: number; // used

	/*
	 * longTermGapMultiplier Range: 0-1 in decimal, ie .3 At 0, we want 0% of our longTermGaps rented - so there will be no adjustment if they rent 6 out of 12
	 * nights with 3 night gaps on each side At 1, we want 100% of our longTermGaps rented - so there would be a 6 night penalty to price if they rent 6 out of 12
	 * nights with 3 night gaps on each side
	 *
	 */
	longTermGapMultiplier: number; // used



	/*
	 *
	 * longTermGapPenaltyPercent' to determine how much penalty to apply. For example, if 3 night gap on each side so we have a 6 night penalty - only apply xxx% of
	 * the penalty (ie .5)
	 */
	longTermGapPenaltyPercent: number; // used


	longTermGapEmptyMultiplier: number; // used
	longTermGapEmptyPenaltyPercent: number; // used


	// % discount for connecting reservations either on the front OR the back, -
	// is discount, + is premium
	connectingFrontOrBackMultiplier: number; // used

	// % discount for connecting reservations either on the front AND the back
	// (back to back)
	connectingFrontAndBackMultiplier: number; // used

	// negative will reduce discount, positive will increase discount
	lengthOfStayDiscountFactorOffset: number; // used

}
